export default __webpack_public_path__ + "static/media/backyard.e31d34b6.jpg";